const setMangueraFusion = newValues => {
  if(newValues.EV_RIGHT_SIDE !== "MANGUERA_RIZADA_TYPE2" &&
    newValues.EV_RIGHT_SIDE !== "MANGUERA_LISA_TYPE2"){
    newValues.EV_RIGHT_SIDE = "MANGUERA_RIZADA_TYPE2"
  }

  newValues.EV_LEFT_SIDE = newValues.EV_RIGHT_SIDE

  if(newValues.EV_LONGITUD_MANGUERA !== "4" &&
    newValues.EV_LONGITUD_MANGUERA !== "5" &&
    newValues.EV_LONGITUD_MANGUERA !== "7"){
    if(newValues.EV_RIGHT_SIDE === "MANGUERA_RIZADA_TYPE2"){
      newValues.EV_LONGITUD_MANGUERA = "4"
    }
    if(newValues.EV_RIGHT_SIDE === "MANGUERA_LISA_TYPE2"){
      newValues.EV_LONGITUD_MANGUERA = "5"
    }
  }

  if(newValues.EV_RIGHT_SIDE === "MANGUERA_RIZADA_TYPE2" && newValues.EV_LONGITUD_MANGUERA === "7"){
    newValues.EV_LONGITUD_MANGUERA = "5"
  }
  if(newValues.EV_RIGHT_SIDE === "MANGUERA_LISA_TYPE2" && newValues.EV_LONGITUD_MANGUERA === "4"){
    newValues.EV_LONGITUD_MANGUERA = "5"
  }
}

export const fusion = newValues => {
  //Tipo instalación
  if (newValues.EV_PAIS === "USA") {
    newValues.EV_INSTALACION = "MONOFASICO"
  }

  //USA
  if(newValues.EV_PAIS === "USA" ){
    if (newValues.EV_TIPO_CONECTOR === "SOCKET_SCHUKO"){
      newValues.EV_TIPO_CONECTOR = "MANGUERA"
    }

    if (newValues.EV_RIGHT_SIDE !== "MANGUERA_LISA_TYPE1" && newValues.EV_RIGHT_SIDE !== "MANGUERA_LISA_NACS"){
      newValues.EV_RIGHT_SIDE = "MANGUERA_LISA_TYPE1"
    }

    if(newValues.EV_LONGITUD_MANGUERA !== "20"){
      newValues.EV_LONGITUD_MANGUERA = "20"
    }

    newValues.EV_LEFT_SIDE = newValues.EV_RIGHT_SIDE
  }

  //ALEMANIA
  if(newValues.EV_PAIS === "ALEMANIA" ){
    //Eichrecht: no se puede montar TPV (lector de tarjetas bancarias)
    newValues.EV_CONTACTLESS = false

    if(newValues.EV_TIPO_CONECTOR === "SOCKET_SCHUKO" && newValues.EV_RIGHT_SIDE !== "SOCKET_CON_SHUTTERS"){
      newValues.EV_RIGHT_SIDE = "SOCKET_CON_SHUTTERS"
      newValues.EV_LONGITUD_MANGUERA = ""
    }
    if(newValues.EV_TIPO_CONECTOR === "MANGUERA" && newValues.EV_RIGHT_SIDE !== "MANGUERA_LISA_TYPE2"){
      newValues.EV_RIGHT_SIDE = "MANGUERA_LISA_TYPE2"
      if(newValues.EV_LONGITUD_MANGUERA !== "5"){
        newValues.EV_LONGITUD_MANGUERA = "5"
      }
    }

    newValues.EV_LEFT_SIDE = newValues.EV_RIGHT_SIDE
  }

  //OTROS
  if(newValues.EV_PAIS === "OTROS"){
    if(newValues.EV_TIPO_CONECTOR === "SOCKET_SCHUKO"){
      newValues.EV_LONGITUD_MANGUERA = ""
      if(newValues.EV_RIGHT_SIDE !== "SOCKET_CON_SHUTTERS" && 
        newValues.EV_RIGHT_SIDE !== "SOCKET_SIN_SHUTTERS" &&
        newValues.EV_RIGHT_SIDE !== "SOCKET_CON_SHUTTERS_SCHUKO_TYPE_E" && 
        newValues.EV_RIGHT_SIDE !== "SCHUKO_TYPE_E" && 
        newValues.EV_RIGHT_SIDE !== "SCHUKO_TYPE_F"){
        newValues.EV_RIGHT_SIDE = "SOCKET_CON_SHUTTERS"
      }

      if(newValues.EV_RIGHT_SIDE === "SOCKET_CON_SHUTTERS" || newValues.EV_RIGHT_SIDE === "SOCKET_CON_SHUTTERS_SCHUKO_TYPE_E"){
        newValues.EV_LEFT_SIDE = "SOCKET_CON_SHUTTERS"
      }

      if(newValues.EV_RIGHT_SIDE === "SOCKET_SIN_SHUTTERS"){
        newValues.EV_LEFT_SIDE = "SOCKET_SIN_SHUTTERS"
      }

      if(newValues.EV_RIGHT_SIDE === "SCHUKO_TYPE_E" && newValues.EV_LEFT_SIDE !== "SOCKET_CON_SHUTTERS" && newValues.EV_LEFT_SIDE !== "SOCKET_SIN_SHUTTERS" && newValues.EV_LEFT_SIDE !== "SCHUKO_TYPE_E"){
        newValues.EV_LEFT_SIDE = "SOCKET_CON_SHUTTERS"
      }

      if(newValues.EV_RIGHT_SIDE === "SCHUKO_TYPE_F" && newValues.EV_LEFT_SIDE !== "SOCKET_CON_SHUTTERS" && newValues.EV_LEFT_SIDE !== "SOCKET_SIN_SHUTTERS"){
        newValues.EV_LEFT_SIDE = "SOCKET_CON_SHUTTERS"
      }
    }

    if(newValues.EV_TIPO_CONECTOR === "MANGUERA"){
      setMangueraFusion(newValues)
    }
  }

  //Diferenciales autorrearmables
  if(newValues.EV_DIFERENCIALES_AUTORREARMABLES.length > 1){
    newValues.EV_DIFERENCIALES_AUTORREARMABLES = newValues.EV_DIFERENCIALES_AUTORREARMABLES.slice(1);
  }

  return newValues
}
